import { gql } from '@apollo/client'
import { useProjectId } from '@btime/react-session'
import React from 'react'

import { accountsClient } from '../../utils/apollo/api'
import { useAlertModal } from '../../utils/routes/modals/modalsActions'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import { useQuery } from '../../utils/apollo/_helpers/useQuery'
import Circle from '../../packages/kiti/components/shapes/Circle'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Panel from '../../packages/kiti/components/structure/Panel'
import Text from '../../packages/kiti/components/presentation/Text'

const QUERY = gql`
  query Project($id: ID) {
    project(id: $id) {
      id
      name
      icon
      color
    }
  }
`

const CurrentProjectBar = () => {
  const navigate = useNavigation()
  const id = useProjectId()
  const { data, loading, status, ...rest } = useQuery(QUERY, {
    client: accountsClient,
    variables: { id },
    skip: !id,
    fetchPolicy: 'cache-first'
  })
  const project = data?.project

  // React.useEffect(() => {
  // if (status !== 'error' && !loading && !!id && !project?.id) {
  // navigate('/home')
  // }
  // }, [project?.id, loading])

  if (!project) return false

  return (
    <Panel
      height={2}
      bgColor="light2"
      width="100%"
      direction="row"
      align="center"
      paddingH={1.5}
      paddingV={1.1}
      gap={0.5}
      noBorder
      shadow="light3"
      radius="0 5px 0 0"
      onClick={() => navigate('/home')}
    >
      <Circle radius={0.3} bgColor={project.color} size={1.5}>
        <Icon name={project.icon} color="white" size={0.9} />
      </Circle>
      <Text color="dark4" size="small" bold>
        {project.name}
      </Text>
    </Panel>
  )
}

export default CurrentProjectBar
